import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {CookieService} from 'ngx-cookie-service';
import {BankIdAuthenticateResponse} from '../types/BankIdAuthenticateResponse';
import {BankIdCollectResponse} from '../types/BankIdCollectResponse';
import {BankIdQrResponse} from '../types/BankIdQrResponse';
import {UserInfo} from '../types/UserInfo';
import {AppConfigService} from './app-config.service';
import {SessionStorageEnum} from '../enums/SessionStorageEnum';

@Injectable()
export class BankidService {
  private apiUrl = '';

  constructor(
    protected appConfigService: AppConfigService,
    protected http: HttpClient,
    protected cookieService: CookieService,
  ) {
    this.setApiUrl();
  }

  public authenticate(): Observable<BankIdAuthenticateResponse> {
    this.removeOrderRef();
    return this.callAuthenticate().pipe(map(this.storeOrderRef));
  }

  public collect(): Observable<BankIdCollectResponse> {
    return this.callCollect().pipe(
      map((res: BankIdCollectResponse): BankIdCollectResponse => {
        if (res.token) {
          localStorage.setItem(SessionStorageEnum.AUTH_TOKEN, res.token);
          this.removeOrderRef();
        }
        return res;
      }),
    );
  }

  public getQr(): Observable<BankIdQrResponse> {
    return this.callGetQr();
  }

  public cancel(): Observable<unknown> {
    return this.callCancel();
  }

  public getUserInfo(): Observable<UserInfo> {
    return this.callGetUserInfo();
  }

  public logout(): Observable<unknown> {
    return this.http.post(`${this.apiUrl}logout`, {}, {withCredentials: true});
  }

  public removeOrderRef(): void {
    localStorage.removeItem('orderRef');
  }

  protected callAuthenticate(): Observable<BankIdAuthenticateResponse> {
    return this.http.post<BankIdAuthenticateResponse>(`${this.apiUrl}authenticate`, {
      withCredentials: true,
    });
  }

  protected callCollect(): Observable<BankIdCollectResponse> {
    return this.http.get<BankIdCollectResponse>(
      `${this.apiUrl}collect?orderRef=${this.getOrderRef()}&cb=${Math.random()}`,
      {withCredentials: true},
    );
  }

  protected callGetQr(): Observable<BankIdQrResponse> {
    return this.http.get<BankIdQrResponse>(`${this.apiUrl}qr?orderRef=${this.getOrderRef()}&cb=${Math.random()}`);
  }

  protected callCancel(): Observable<unknown> {
    return this.http.post(`${this.apiUrl}cancel?orderRef=${this.getOrderRef()}`, {});
  }

  protected callGetUserInfo(): Observable<UserInfo> {
    return this.http.get<UserInfo>(`${this.appConfigService.appConfig.apiUrl}user/info?cb=${Math.random()}`, {
      withCredentials: true,
    });
  }

  protected getOrderRef(): string {
    return localStorage.getItem('orderRef');
  }

  private setApiUrl(): void {
    const bankIdSevenCookie = this.cookieService.get('bankIdSeven');

    this.apiUrl = this.appConfigService.appConfig.features.useNewBankId
      ? 'https://bankid.varden.se/api/varden/'
      : bankIdSevenCookie === '1'
        ? 'https://bankid.varden.se/api/varden/'
        : `${this.appConfigService.appConfig.apiUrl}bankid/`;
  }

  private storeOrderRef(res: BankIdAuthenticateResponse): BankIdAuthenticateResponse {
    localStorage.setItem('orderRef', res.orderRef);
    return res;
  }
}
